// extracted by mini-css-extract-plugin
module.exports = {"passLabel":"InstanceAuth_style_passLabel__2Zdf2"};